import { render, staticRenderFns } from "./WorkingOnDetailsModal.vue?vue&type=template&id=407892ba&"
import script from "./WorkingOnDetailsModal.vue?vue&type=script&lang=js&"
export * from "./WorkingOnDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports